import { useAsyncDataWithCapture } from '~/composables/useAsyncDataWithCapture'
import { useCurrentLocationAccount } from '~/composables/useCurrentLocationAccount'
import {
  createOperator,
  getOperator,
  getOperators,
  updateOperator,
} from '~/repositories/operatorRepository'

export const useOperator = () => {
  return {
    getOperator,
    getOperators,
    createOperator,
    updateOperator,
  }
}

export const useFetchOperators = async () => {
  const { currentLocationAccount } = useCurrentLocationAccount()
  return await useAsyncDataWithCapture(
    async () => {
      if (!currentLocationAccount.value?.location_id) return []
      return await getOperators(currentLocationAccount.value.location_id)
    },
    {
      watch: [currentLocationAccount],
    }
  )
}
